/**
 * 브랜드 허브 머리에서 고를 수 있는 채널 — **집계가 세는 채널 전부**다(상세 · 공유 링크가 같은 목록).
 * ⚠️ 소셜 다섯만 두면 도넛에는 `naverblog`·`atcosme` 가 나오는데 고르개에는 없어 좁힐 수가 없다.
 */

import { type MediaChannel, MEDIA_ORGANIC_CHANNEL_GROUPS } from 'src/sections/search-all/constants/search-all-media';

export const BRAND_HUB_CONTENT_CHANNELS: readonly MediaChannel[] = MEDIA_ORGANIC_CHANNEL_GROUPS.flatMap((group) => group.channels);

/**
 * 크리에이터 면이 묻는 채널 — **SNS 다섯**(인스타그램 · 틱톡 · 유튜브 · X · 스레드)만.
 * ⚠️ 블로그·카페·커뮤니티 글쓴이는 크리에이터가 아니다 — 섞이면 요약의 인원·집중도와 표가 일반 작성자로 채워진다.
 */
export const BRAND_HUB_CREATOR_CHANNELS: readonly MediaChannel[] = MEDIA_ORGANIC_CHANNEL_GROUPS[0].channels;

/**
 * 머리에서 고른 채널 → 크리에이터 면이 물을 채널. 비었으면 SNS 다섯, 고른 것이 있으면 SNS 다섯과 겹치는 것만.
 * @returns `none` 이 참이면 겹치는 채널이 없다(묻지 않고 빈 면)
 */
export function toCreatorChannels(picked: readonly MediaChannel[]): { channels: readonly MediaChannel[]; none: boolean } {
  if (picked.length === 0) return { channels: BRAND_HUB_CREATOR_CHANNELS, none: false };
  const channels = picked.filter((channel) => BRAND_HUB_CREATOR_CHANNELS.includes(channel));
  return { channels, none: channels.length === 0 };
}
